module.exports = __webpack_public_path__ + "img/info.8d85326f.svg";